import type { PageContext } from '@zto/zpage-runtime'
import { uuid } from '@zto/zpage'
import { SysConfigPaths } from '@/config'
import { getTdlNumber } from '@/utils'

export function buildingDictDialog(isEdit: boolean) {
  return {
    width: 420,
    labelWidth: 110,
    itemSpan: 24,
    title: isEdit ? '编辑楼栋号' : '添加楼栋号',
    onShow: async ({ app, data }: PageContext) => {
      if(!isEdit) {
        return {
          payload: {
            name: undefined,
            tdlNumber: undefined
          }
        }
      }
      return {
        payload: {
          ...data,
          tdlNumber: data?.data?.tdlNumber || ''
        }
      }
    },

    formItems: [
      {
        type: 'input',
        prop: 'name',
        label: '楼栋号',
        required: true,
        trim: true,
        maxlength: 6
      },
      {
        type: 'input',
        prop: 'tdlNumber',
        label: '楼栋号通信码',
        trim: true,
        maxlength: 10,
        visibleOn: `${isEdit}`, // 编辑时 显示
        dynamicAttrs: ({ data, app }: PageContext) => {
          return {
            required: !!isEdit,
          }
        }
      }
    ],

    beforeSubmit: async ({ data }: PageContext, model: any, options: any) => {
      const { tdlNumber, name, ...other} = data || {}
      if(!isEdit){
        return {
          parentNodePath: SysConfigPaths.BUILDING_DICT,
          code: uuid(),
          name,
          // sort: 1,
          status: 1, // 1:启用 0:禁用
          data: {
            tdlNumber: getTdlNumber(name)
          }
        }
      }
      return {
        ...other,
        name,
        data: {
          tdlNumber
        }
      }
    },

    actions: {
      close: {},
      submit: { label: '确定' }
    }
  }
}



export function buildingDictBatchDialog() {
  return {
    width: 420,
    labelWidth: 110,
    itemSpan: 24,
    title: '批量添加楼栋号',

    formItems: [
      {
        type: 'input-number',
        prop: 'startFloor',
        label: '起始楼栋号',
        min: 1,
        precision: 0,
        required: true,
        dynamicAttrs: ({ data, app }: PageContext) => {
          return {
            max: data.endFloor ?? 100
          }
        }
      },
      {
        type: 'input-number',
        prop: 'endFloor',
        label: '终点楼栋号',
        max: 100,
        precision: 0,
        required: true,
        dynamicAttrs: ({ data, app }: PageContext) => {
          return {
            min: data.startFloor ?? 1
          }
        }
      }
    ],

    beforeSubmit: async ({ app, data }: PageContext, model: any, options: any) => {
      const { startFloor, endFloor } = data || {}
      const { Message } = app.useMessage()
      if (startFloor > endFloor) {
        Message.warning('起始楼栋号不能大于终点楼栋号')
        return false
      }
      const nodeList = Array.from({ length: endFloor - startFloor + 1 }, (_, i) => {
        return {
          code: uuid(),
          name: `${startFloor + i}栋`,
          // sort: 1,
          status: 1,
          data: {
            tdlNumber: startFloor + i // 示例逻辑，可按需修改
          }
        };
      });


      return {
        parentNodePath: SysConfigPaths.BUILDING_DICT,
        nodeList
      }
    },

    actions: {
      close: {},
      submit: { label: '确定' }
    }
  }
}
